<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 5C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41421L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L17.5858 5H14ZM6 7C5.44772 7 5 7.44772 5 8V18C5 18.5523 5.44772 19 6 19H16C16.5523 19 17 18.5523 17 18V14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14V18C19 19.6569 17.6569 21 16 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H10C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7H6Z"
    fill="currentColor"
  />
</template>
